import { render } from "./SkinBlock.vue?vue&type=template&id=5efa0e38"
import script from "./SkinBlock.vue?vue&type=script&lang=js"
export * from "./SkinBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__